// Sticky filters (e.g. "Days in") remember the last choice in this browser and apply it on every
// dashboard that has the same filter. Storage can be unavailable (private windows): then the
// choice simply applies to the current page.
import type { FilterDef } from '../app/types';

const KEY = (id: string) => `msld.filter.${id}`;

/** The remembered choice for a sticky filter, if it is still one of its options. */
export function rememberedChoice(f: FilterDef): string | undefined {
  if (!f.sticky) return undefined;
  try {
    const v = localStorage.getItem(KEY(f.id));
    return v !== null && (!f.options || f.options.some((o) => o.value === v)) ? v : undefined;
  } catch {
    return undefined;
  }
}

export function rememberChoice(f: FilterDef | undefined, v: unknown) {
  if (!f?.sticky || typeof v !== 'string') return;
  try {
    localStorage.setItem(KEY(f.id), v);
  } catch {
    // Storage unavailable: nothing to remember.
  }
}
